<template>
  <div>
    <v-card>
      <div>
        <v-toolbar
          light
          color="white"
          class="elevation-2"
        >
          <v-toolbar-title>
            Historia rozliczeń
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip left>
            <v-btn
              icon
              slot="activator"
              @click.prevent="showDialog('add')"
            >
              <v-icon color="primary">note_add</v-icon>
            </v-btn>
            <span>Dodaj rozliczenie</span>
          </v-tooltip>
        </v-toolbar>
      </div>
      <SubscriptionsList />
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SubscriptionsList from './SubscriptionsList.vue';

export default {
  name: 'subscriptions',
  components: { SubscriptionsList },
  computed: {
    ...mapGetters('subscriptions', [
      'subscriptionsList',
    ]),
  },
  methods: {
    ...mapActions('subscriptions', [
      'setDialogVisbility',
    ]),
    showDialog(type) {
      this.setDialogVisbility({ type, id: this.subscriptionId });
    },
  },
};
</script>
